import { render } from "./MovAlmacenList.vue?vue&type=template&id=10e68d5a&scoped=true"
import script from "./MovAlmacenList.vue?vue&type=script&lang=js"
export * from "./MovAlmacenList.vue?vue&type=script&lang=js"

import "./MovAlmacenList.vue?vue&type=style&index=0&id=10e68d5a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e68d5a"]])

export default __exports__